import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-icon-1-6-0{display:inline-block;width:20px;height:20px;vertical-align:middle;fill:#444}.hcr-icon--xs-1-6-0{width:12px;height:12px}.hcr-icon--sm-1-6-0{width:24px;height:24px}.hcr-icon--md-1-6-0{width:36px;height:36px}.hcr-icon--lg-1-6-0{width:48px;height:48px}.hcr-icon--cover-1-6-0{width:100%;height:100%}.hcr-icon-1-6-0 svg{display:block;max-width:100%}",
map:{"hcr-icon":"hcr-icon-1-6-0","hcr-icon--xs":"hcr-icon--xs-1-6-0","hcr-icon--sm":"hcr-icon--sm-1-6-0","hcr-icon--md":"hcr-icon--md-1-6-0","hcr-icon--lg":"hcr-icon--lg-1-6-0","hcr-icon--cover":"hcr-icon--cover-1-6-0"}};

var bem = Bem('icon', styles);
var Icon = function Icon(_ref) {
  var extraClasses = _ref.extraClasses,
      InlineIcon = _ref.InlineIcon,
      size = _ref.size,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["extraClasses", "InlineIcon", "size", "title"]);

  return React.createElement("span", _extends({
    className: "".concat(bem.b(size, [extraClasses]))
  }, rest), InlineIcon && !title && React.createElement(InlineIcon, null), InlineIcon && title && React.createElement(InlineIcon, {
    title: title
  }));
};
Icon.displayName = 'Icon';
Icon.defaultProps = {
  extraClasses: '',
  size: null,
  title: null
};
Icon.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Needs to be an svg inline icon */
  InlineIcon: PropTypes.func.isRequired,

  /** Size of the icon, 20px if none provided, "cover" fills all available space */
  size: PropTypes.oneOf([null, 'xs', 'sm', 'md', 'lg', 'cover']),

  /** Custom title for Icon, replaces the default one provided with SVG */
  title: PropTypes.string
};
var Icon$1 = Injecss(Icon, styles);

export { Icon$1 as Icon };
